var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Popup } from '@workday/canvas-kit-react/popup';
import { space, colors, type } from '@workday/canvas-kit-react/tokens';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
import { checkIcon, exclamationCircleIcon } from '@workday/canvas-system-icons-web';
import { createComponent, styled } from '@workday/canvas-kit-react/common';
import { Hyperlink } from '@workday/canvas-kit-react/button';
var toastWidth = 360;
var ToastContentContainer = styled('div')(__assign({ display: 'flex', alignItems: 'center' }, type.levels.subtext.large), function (_a) {
    var onClose = _a.onClose;
    return ({
        marginRight: onClose ? space.m : undefined,
    });
});
var ToastSystemIcon = styled(SystemIcon)({
    marginRight: space.s,
    alignSelf: 'start',
});
var _a = type.levels.subtext.large, color = _a.color, subTextLargeStyles = __rest(_a, ["color"]);
var StyledActionButton = styled(Hyperlink)(__assign(__assign({}, subTextLargeStyles), { display: 'block', backgroundColor: 'transparent', border: 'none', marginTop: space.xxxs }));
var Message = styled('div')({
    wordBreak: 'break-word',
});
export var Toast = createComponent('div')({
    displayName: 'Toast',
    Component: function (_a, ref, Element) {
        var _b = _a.icon, icon = _b === void 0 ? checkIcon : _b, // needed for TS2742 - https://github.com/microsoft/TypeScript/issues/29808
        _c = _a.iconColor, // needed for TS2742 - https://github.com/microsoft/TypeScript/issues/29808
        iconColor = _c === void 0 ? colors.greenApple400 : _c, onClose = _a.onClose, onActionClick = _a.onActionClick, actionText = _a.actionText, children = _a.children, elemProps = __rest(_a, ["icon", "iconColor", "onClose", "onActionClick", "actionText", "children"]);
        var isInteractive = onClose || onActionClick;
        var isError = iconColor === colors.cinnamon500 && icon === exclamationCircleIcon;
        return (React.createElement(Popup.Card, __assign({ ref: ref, as: Element, width: toastWidth, depth: 5, role: isInteractive ? 'dialog' : isError ? 'alert' : 'status', "aria-live": isInteractive ? 'off' : isError ? 'assertive' : 'polite', "aria-atomic": !isInteractive, padding: "xxs" }, elemProps),
            onClose && React.createElement(Popup.CloseIcon, { "aria-label": "Close", onClick: onClose, size: "small" }),
            React.createElement(Popup.Body, null,
                React.createElement(ToastContentContainer, { onClose: onClose },
                    icon && React.createElement(ToastSystemIcon, { color: iconColor, colorHover: iconColor, icon: icon }),
                    React.createElement(Message, null,
                        children,
                        onActionClick && (React.createElement(StyledActionButton, { as: "button", onClick: onActionClick }, actionText)))))));
    },
});
